import httpClient from "../../../../shared/api/httpClient";

function buildQuery(params = {}) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.set(key, String(value));
    }
  });

  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export function listEvaluaciones(params = {}) {
  return httpClient.get(`/hr/areas/evaluations${buildQuery(params)}`);
}

export function createEvaluacion(payload) {
  return httpClient.post("/hr/areas/evaluations", payload);
}

export function getEvaluacion(evaluationId) {
  return httpClient.get(`/hr/areas/evaluations/${evaluationId}`);
}

export function updateEvaluacion(evaluationId, payload) {
  return httpClient.patch(`/hr/areas/evaluations/${evaluationId}`, payload);
}

export function archiveEvaluacion(evaluationId) {
  return httpClient.patch(`/hr/areas/evaluations/${evaluationId}/archive`, {});
}

export function deleteEvaluacion(evaluationId) {
  return httpClient.delete(`/hr/areas/evaluations/${evaluationId}`);
}

export function previewEvaluacionScope(payload) {
  return httpClient.post("/hr/areas/evaluations/scope-preview", payload);
}

export function getEvaluacionResults(evaluationId) {
  return httpClient.get(`/hr/areas/evaluations/${evaluationId}/results`);
}

export function getEvaluacionAssigneeResult(evaluationId, assigneeId) {
  return httpClient.get(`/hr/areas/evaluations/${evaluationId}/results/${assigneeId}`);
}

export function gradeEvaluacionAssignee(evaluationId, assigneeId, payload) {
  return httpClient.patch(
    `/hr/areas/evaluations/${evaluationId}/results/${assigneeId}/grade`,
    payload
  );
}